import React from 'react';
import {
  Button, Input, InputNumber, Popover,
} from 'antd';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMinusCircle } from '@fortawesome/pro-light-svg-icons';
import { bindActionCreators } from 'redux';
import { Text, Box, ShowIf } from '../../../shared/components';
import NumberFormat from '../../../shared/components/dataDisplay/NumberFormat';
import TwoColumnsFlexLayout from '../../../shared/components/layout/TwoColumnsFlex.layout';
import DescuentosTabs from '../../containers/creador/DescuentosTabs.dataentry';
import { detalleCreacionType, encargoCreacionType } from '../../types/encargo.creacion.types';
import PopoverNumeroDeLote from '../../containers/creador/PopoverEditorNumero.dataentry';
import { modificarNumeroLote } from '../../../../state/actions/creators/encargos.creador.actioncreator';

//TODO: A BORRAR COMPONENTE
class SeleccionadorArticulo extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      descuentoVisible: false,
    };
    this.descuentosTabRef = React.createRef();
  }

  render() {
    const {
      detalle,
      onBuscarCodigoArticulo,
      onClickSeleccionarArticulo,
      onClickEliminarArticulo,
      onAplicarDescuento,
      cargandoBusqueda,
      onChangeUnidades,
      encargo,
      onBorrarTodo,
      modificarNumeroLote,
    } = this.props;
    const { descuentoVisible } = this.state;
    const {
      articulo,
      descripcion,
      obligatorio,
      etiqueta,
      unidades,
      estructuraId,
      precio: precioConDescuento,
      eliminable,
      cadenaTipo,
      numeroLote,
      linea,
    } = detalle;

    const encargoUUID = encargo ? encargo.uuid : null;
    const precioOriginal = articulo ? articulo.pvp : 0;
    const hayDescuentoAplicado = precioOriginal !== precioConDescuento;

    const LabelObligatorio = obligatorio ? <Text mt="8" color="gray" fontSize="12" translationId="encargos.articulo_obligatorio" /> : null;
    const BuscadorArticulos = (
      <Input
        disabled={cargandoBusqueda}
        onPressEnter={(e) => {
          onBuscarCodigoArticulo({ codigo: e.target.value });
        }}
        placeholder="Introducir código"
        size="small"
        style={{ minWidth: '138px', width: 'auto' }}
      />
    );

    let tipoArticuloCadena = '';
    if (etiqueta) {
      tipoArticuloCadena = etiqueta.toLowerCase();
    } else if (cadenaTipo) {
      tipoArticuloCadena = cadenaTipo.toLowerCase();
    }

    const sePuedeEliminarLaLinea = eliminable === true || articulo;

    const EliminadorDeLinea = (
      <ShowIf condition={sePuedeEliminarLaLinea}>
        <Box display="inline-block" mr="8">
          <Button
            disabled={!sePuedeEliminarLaLinea}
            onClick={() => onClickEliminarArticulo()}
            type="link"
            style={{ padding: 0, height: 'auto' }}
          >
            <FontAwesomeIcon icon={faMinusCircle} style={{ color: 'red' }} />
          </Button>
        </Box>
      </ShowIf>
    );

    const ModificadorDeUnidades = (
      <InputNumber
        disabled={estructuraId != null || (articulo === undefined)}
        size="small"
        max={100}
        style={{ width: '52px' }}
        value={unidades}
        onChange={(unidades) => {
          if (onChangeUnidades && typeof onChangeUnidades === 'function') {
            onChangeUnidades({ unidades });
          }
        }}
      />
    );


    const SelectorBuscadorArticulo = (
      <Box>
        <Button
          disabled={cargandoBusqueda}
          style={{ height: '24px', padding: 0, display: 'inline-block' }}
          type="link"
          onClick={() => onClickSeleccionarArticulo()}
        >
          <Text translationId="generico.seleccionar" mr="4" />
          { tipoArticuloCadena }
        </Button>
        <ShowIf condition={onBuscarCodigoArticulo && typeof onBuscarCodigoArticulo === 'function'}>
          { ' o ' }
          { BuscadorArticulos }
        </ShowIf>
      </Box>
    );

    const DescripcionArticulo = (
      <Text style={{ height: '24px', lineHeight: '24px' }} display="inline-block">{ descripcion }</Text>
    );


    const hayArticuloSeleccionado = articulo === undefined || articulo === null;


    return (
      <Box mb="16">
        <Box>
          <TwoColumnsFlexLayout
            flexLeft={4}
            leftContent={(
              <Box style={{ whiteSpace: 'nowrap', overflow: 'hidden' }}>
                <Box mr="8" display="inline-block" style={{ verticalAlign: 'top' }}>
                  { EliminadorDeLinea }
                  { ModificadorDeUnidades }
                </Box>
                <Box display="inline-block" style={{ verticalAlign: 'top' }}>
                  <Box>
                    <ShowIf condition={(hayArticuloSeleccionado)}>
                      { SelectorBuscadorArticulo }
                    </ShowIf>

                    <ShowIf condition={articulo}>
                      { DescripcionArticulo }
                    </ShowIf>
                  </Box>
                  <Box>
                    <PopoverNumeroDeLote
                      title={<Text pt="4" translationId="encargos.numero_lote" fontWeight="semibold" />}
                      label={<Text fontSize="12" translationId="encargos.numero_lote" />}
                      numero={numeroLote}
                      onAplicar={({ valor }) => {
                        modificarNumeroLote({ encargoUUID, linea, numeroLote: valor });
                      }}
                    />
                    { LabelObligatorio }
                  </Box>
                </Box>
              </Box>
            )}
            rightContent={(
              <Box style={{ float: 'right' }}>
                <ShowIf condition={articulo}>
                  <Box display="inline-block" style={{ verticalAlign: 'top' }}>
                    <Box style={{ textAlign: 'right' }}>
                      <ShowIf condition={hayDescuentoAplicado === true}>
                        <NumberFormat
                          color="gray"
                          style={{ textDecoration: 'line-through', lineHeight: '24px' }}
                          display="inline-block"
                          fontSize="12"
                          number={precioOriginal * unidades}
                          mr="8"
                        />
                      </ShowIf>
                      <NumberFormat
                        style={{ lineHeight: '24px' }}
                        textAlign="right"
                        display="inline-block"
                        number={(hayDescuentoAplicado) ? precioConDescuento * unidades : precioOriginal * unidades}
                      />
                    </Box>
                    <Popover
                      overlayClassName="no-padding"
                      onVisibleChange={(visible) => {
                        if (visible && this.descuentosTabRef && this.descuentosTabRef.current) {
                          this.descuentosTabRef.current.initState();
                        }
                      }}
                      content={(
                        <DescuentosTabs
                          ref={this.descuentosTabRef}
                          encargo={encargo}
                          detalle={detalle}
                          onClose={() => this.setState({ descuentoVisible: false })}
                          onAplicar={(state) => {
                            if (onAplicarDescuento && typeof onAplicarDescuento === 'function') {
                              onAplicarDescuento(state);
                            }
                            this.setState({ descuentoVisible: false });
                          }}
                          onBorrarTodo={() => {
                            if (onBorrarTodo && typeof onBorrarTodo === 'function') {
                              onBorrarTodo();
                            }
                          }}
                        />
                      )}
                      trigger="click"
                      visible={descuentoVisible}
                    >
                      <Button
                        type="link"
                        style={{ padding: 0, height: 'auto', float: 'right' }}
                        onClick={() => this.setState({ descuentoVisible: true })}
                      >
                        <Text
                          textAlign="right"
                          display="block"
                          mt="8"
                          fontSize="12"
                          translationId="encargos.descuento"
                        />
                      </Button>
                    </Popover>
                  </Box>
                </ShowIf>
              </Box>
            )}
          />
        </Box>
      </Box>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    modificarNumeroLote,
  }, dispatch);
}

SeleccionadorArticulo.propTypes = {
  encargo: encargoCreacionType.isRequired,
  cargandoBusqueda: PropTypes.bool,
  detalle: detalleCreacionType.isRequired,
  onBuscarCodigoArticulo: PropTypes.func,
  onClickEliminarArticulo: PropTypes.func,
  onClickSeleccionarArticulo: PropTypes.func,
  onAplicarDescuento: PropTypes.func,
  onChangeUnidades: PropTypes.func,
  onBorrarTodo: PropTypes.func,
};

SeleccionadorArticulo.defaultProps = {
  cargandoBusqueda: null,
  onBuscarCodigoArticulo: null,
  onAplicarDescuento: null,
  onChangeUnidades: null,
  onBorrarTodo: null,
  onClickEliminarArticulo: () => {},
  onClickSeleccionarArticulo: () => {},
};

export default connect(
  null,
  mapDispatchToProps,
)(SeleccionadorArticulo);
